import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { getIsLogin } from 'eco-design-reliance/getIsLogin';
import getLocal from 'eco-design-reliance/getLocal';
import React, { Fragment, useEffect, useRef, useState } from 'react';
//import EcoCartItems from './EcoCartItems';
import { shoppingCartLocale, shoppingCartPathname } from './common';
//import EcoCartItems from './EcoCartItems';
import dynamic from 'next/dynamic';
import gtm from 'eco-design-reliance/gtm';
import './index.scss';

const EcoCartItems = dynamic(() => import('./EcoCartItems'));

export interface EcoCartProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 系统时间
     */
    systemTimestamp?: number;
    /**
     * iconUrl
     */
    iconUrl?: string;
}
const localStorageHaveCartItems = (localStorageKey: string) => {
    if (typeof window === 'undefined') {
        return false;
    }
    const itemsA = JSON.parse(localStorage.getItem(localStorageKey) || '[]');
    if (itemsA.length) {
        return true;
    }
    return false;
};
/**
 * 维护:谢保林
 *
 * 购物车
 */
const EcoCart: React.FC<EcoCartProps> = ({ systemTimestamp, className, iconUrl }) => {
    const systemTimestamp2 = systemTimestamp || Date.now();
    const [firstOpenC, setFirstOpenC] = useState(false);
    const [isOpenA, setIsOpenA] = useState(false);
    const isOpenB = useRef(false);
    const { locale = 'us', pathname = '' } = getLocal();
    const openFlagA1 = shoppingCartPathname?.includes(pathname) && shoppingCartLocale?.[pathname]?.includes(locale);
    const openFlagA2 = pathname.includes('/pages/');
    const openFlagA3 = pathname.includes('/ecocredits');
    const openFlagA4 = pathname.includes('/ecocredits-monthly-madness');
    const isShoppingCart = openFlagA1 || openFlagA2 || openFlagA3 || openFlagA4; // 是否打开购物车
    const localStorageKey = `ecoCartItems_${locale}`;
    const focusFlagA = useRef(false);
    const initHandleAll = () => {
        // 打开购物车
        EcoDesignEventsBus.on('eco-cart-open', () => {
            if (isOpenB.current) {
                EcoDesignEventsBus.emit('__eco-cart-open');
            } else {
                setIsOpenA(true);
                isOpenB.current = true;
                setTimeout(() => {
                    EcoDesignEventsBus.emit('__eco-cart-open');
                }, 800);
            }
            setFirstOpenC(true);
        });
        // 添加到购物车|可增加,也可删除
        EcoDesignEventsBus.on('eco-cart-add', (list: any[], modelType?: string) => {
            if (!isOpenB.current) {
                const displayTypeMap = {
                    'AI Recommend Search': 'Recommend Bundles',
                    'AI Brand Member Recommend': 'Recommend Bundles',
                };
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'official_view_cart',
                    page_name: 'none',
                    display_type: displayTypeMap?.[modelType as keyof typeof displayTypeMap] || 'none',
                    module_referral: modelType || 'none',
                });

                setIsOpenA(true);
                isOpenB.current = true;
                setTimeout(() => {
                    EcoDesignEventsBus.emit('__eco-cart-open');
                }, 800);
                setTimeout(() => {
                    EcoDesignEventsBus.emit('__eco-cart-add', list);
                }, 1200);
            } else {
                setIsOpenA(true);
                isOpenB.current = true;
                EcoDesignEventsBus.emit('__eco-cart-add', list);
            }
            setFirstOpenC(true);
        });
        initBindEventsHandleA();
    };
    const initBindEventsHandleA = () => {
        if (focusFlagA.current) {
            return;
        }
        focusFlagA.current = true;
        setTimeout(() => {
            focusFlagA.current = false;
        }, 500);
        const isLoginA = getIsLogin();
        const localStorageHasLen = localStorageHaveCartItems(localStorageKey);

        if (isLoginA && !isOpenB.current) {
            setIsOpenA(true);
            isOpenB.current = true;
            //cancelEventsHandle();
        } else if (localStorageHasLen) {
            setIsOpenA(true);
            isOpenB.current = true;
            //cancelEventsHandle();
        }
    };
    const bindEventsHandle = () => {
        window.addEventListener('pageshow', initBindEventsHandleA, false);
        window.addEventListener('focus', initBindEventsHandleA);
        document.addEventListener('visibilitychange', initBindEventsHandleA);
    };
    const cancelEventsHandle = () => {
        window.removeEventListener('pageshow', initBindEventsHandleA, false);
        window.removeEventListener('focus', initBindEventsHandleA);
        document.removeEventListener('visibilitychange', initBindEventsHandleA);
    };
    useEffect(() => {
        initHandleAll();
        //bindEventsHandle();
    }, []);

    return (
        <Fragment>
            {/* <div className="WidgetsItem WidgetsItem-GloCart">
                <EcoCartIconL iconUrl={iconUrl} />
            </div> */}

            {isOpenA && <EcoCartItems systemTimestamp={systemTimestamp2} />}
            {firstOpenC && <div className="eco-cart-open-pathname"></div>}
        </Fragment>
    );
};

export default EcoCart;
